<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>厂商管理</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="厂商名称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="shortName"
            label="厂商简称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="address"
            label="厂商地址"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="creatTime"
            label="创建时间"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.creatTime | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="linker"
            label="管理员姓名"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="linkerTel"
            label="管理员电话"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" style="fontSize:19px;color:#000"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'" :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:100%;margin:0 auto;marginTop:-30px">
            <div class="dialogline"></div>
            <div class="dialogdiv">
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules" >
                    <el-form-item label="厂商名称" label-width="105px" prop="name">
                        <el-input v-model="dialogForm.name" autocomplete="off" placeholder="请输入厂商名称" ></el-input>
                    </el-form-item>
                    <el-form-item label="厂商简称" label-width="105px" prop="shortName">
                        <el-input v-model="dialogForm.shortName" autocomplete="off" placeholder="请输入厂商简称" ></el-input>
                    </el-form-item>
                    <el-form-item label="厂商地址" label-width="105px" prop="address" >
                        <el-input v-model="dialogForm.address" autocomplete="off" placeholder="请输入厂商地址" @input="getAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员姓名" label-width="105px" prop="linker" >
                        <el-input v-model="dialogForm.linker" autocomplete="off" placeholder="请输入管理员姓名" ></el-input>
                    </el-form-item>
                    <el-form-item label="管理员电话" label-width="105px" prop="linkerTel" >
                        <el-input v-model="dialogForm.linkerTel" autocomplete="off" placeholder="请输入管理员电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="默认密码" label-width="105px" prop="defaultPwd" >
                        <el-input v-model="dialogForm.defaultPwd" autocomplete="off" placeholder="请输入默认密码" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="map">
                    <baidu-map
                        :center="center"
                        :zoom="zoom"
                        :scroll-wheel-zoom="true"
                        @click="getLocation"
                        
                    >
                        <bm-view style="width: 100%; height: 400px; flex: 1"></bm-view>
                        <bm-marker :position="markerCenter" :dragging="true" animation="BMAP_ANIMATION_DROP" @dragend='getLocation'>
                        </bm-marker>
                    </baidu-map>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        var validatePhone = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入手机号"));
            } else if (!/^1[123456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        };
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                name: '',
                shortName: '',
                address: '',
                linker: '',
                linkerTel: '',
                gpsX: 0,
                gpsY: 0,
                defaultPwd: '',
            },
            center: {
                lng: 116.404,
                lat: 39.915,
            },
            zoom: 15,
            markerCenter:{
                lng: 116.404,
                lat: 39.915,
            },
            formRules:{
                name:[{
                    required: true,
                    message: "请输入厂商名称",
                    trigger: "blur"
                }],
                shortName:[{
                    required: true,
                    message: "请输入厂商简称",
                    trigger: "blur"
                }],
                address:[{
                    required: true,
                    message: "请输入厂商地址",
                    trigger: "blur"
                }],
                linker:[{
                    required: true,
                    message: "请输入管理员姓名",
                    trigger: "blur"
                }],
                linkerTel:[{
                    required: true,
                    validator: validatePhone,
                    trigger: "blur"
                }],
                defaultPwd:[{
                    required: true,
                    message: "请输入默认密码",
                    trigger: "blur"
                }]
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            list: [],
            inputValue: ''
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.GroupList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total
            })
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //获取项目地址
        getAddress(){
            this.center = this.dialogForm.address
        },
        //点击地图获取坐标
        getLocation(e){
            this.markerCenter.lng = e.point.lng;
            this.markerCenter.lat = e.point.lat;
            this.dialogForm.gpsX =  e.point.lng;
            this.dialogForm.gpsY =  e.point.lat
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                shortName: '',
                address: '',
                linker: '',
                linkerTel: '',
                gpsX: 0,
                gpsY: 0,
                defaultPwd: '',
            };
            this.center = {
                lng: 116.404,
                lat: 39.915,
            }
            this.markerCenter = {
                lng: 116.404,
                lat: 39.915,
            }
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                name: row.name,
                shortName: row.shortName,
                address: row.address,
                linker: row.linker,
                linkerTel: row.linkerTel,
                gpsX: row.gpsX,
                gpsY: row.gpsY,
                defaultPwd: row.defaultPwd,
            };
            this.center = {
                lng: row.gpsX,
                lat: row.gpsY,
            }
            this.markerCenter = {
                lng: row.gpsX,
                lat: row.gpsY,
            }
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    if(this.isEdit){
                        this.$api.UpdateGroup(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }else{
                        this.$api.CreateGroup(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }
                    this.dialogFormVisible = false;
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
.dialogdiv{
    display: flex;
    justify-content: space-between;
    height: 400px;
    width: 100%;
    .el-form{
        width: 46%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 0;
        border-right:1px solid #ccc;
        padding-right: 20px;
    }
    .map{
        width: 52%;
        height: 100%;
    }
}
</style>